import { createSvg } from '../createSvg';
var Crown = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1.5 : _b;
    return (<>
            <g id={'contour'}>
                <path d='M16.7 18.98H7.29995C6.87995 18.98 6.40995 18.65 6.26995 18.25L2.12995 6.66999C1.53996 5.00999 2.22996 4.49999
                     3.64996 5.51999L7.54995 8.30999C8.19995 8.75999 8.93995 8.52999 9.21995 7.79999L10.98 3.10999C11.54 1.60999 12.47
                      1.60999 13.03 3.10999L14.79 7.79999C15.07 8.52999 15.81 8.75999 16.45 8.30999L20.11 5.69999C21.67 4.57999 22.42
                       5.14999 21.78 6.95999L17.74 18.27C17.59 18.65 17.12 18.98 16.7 18.98Z' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
            </g>
            <g id={'guts'}>
                <path d='M6.5 22H17.5' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
                <path d='M9.5 14H14.5' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
            </g>
        </>);
};
export default createSvg(Crown, 'crown');
